/** @jsx jsx */

import { css, jsx } from "@emotion/react";
import bgLeft from "../../../images/biz-advice-left.svg";
import bgRight from "../../../images/biz-advice-right.svg";
import { withPrefix } from "gatsby-link";
import { CarouselCommon } from "./CarouselCommon";
import WrapCardCommon from "./WrapCardCommon";

const WrapBizAdvice = ({ data }) => {
    const cards = data.filter(item => item.node.tags.some(el=>el.slug==="biz-advice")).slice(0, 10).map( (item, index) => {
        return { display:<WrapCardCommon post={item.node} id={index}/>, key: index}
    });
    return (
            <section
                css={css`
                    width: 100%;
                    position: relative;
                    background: url(${bgLeft}) bottom 22rem left / 25%,
                        url(${bgRight}) top 1rem right / 25%,
                        linear-gradient(180deg, #F3CF73 82.25%, #EBF4FA 100%);
                    background-repeat: no-repeat;
                    text-align: center;
                    height: 110rem;
                    padding-top: 6rem; 
                `}
            >
                <div>
                <h1 css={css`
                    color: #DC5E72;
                    font-size: 8rem;
                    text-align: center;
                    line-height: 10rem;
                    @media(max-width: 1024px){
                        font-size: 5rem;
                        line-height: 5rem;
                    }
                `}>
                    Biz Advice
                </h1>
                <p css={css`
                    margin: auto;
                    max-width: 60rem;
                    color: #616161;
                    font-size: 1.5rem;
                    line-height: 2.4rem;
                    @media(max-width: 1024px){
                        max-width: 40rem;
                    }
                `}>We share helpful resources and tips for modern businesses, makers, and brands. Hear from industry leaders and experts, and learn all about running your business, growing your brand, and leveling up your skills as an entrepreneur.</p>
                <a
                    css={css`
                        font-size: 1.6rem;
                        font-weight: 400;
                        line-height: 1.6;
                        padding: 1rem 4rem;
                        color: #DC5E72;
                        border-radius: 1rem;
                        border: 0.2rem solid #DC5E72;
                        cursor: pointer;
                        display: inline-block;
                        margin: 2rem auto;
                    `}
                    href={withPrefix("/biz-advice/")}
                >
                    See More
                </a>

                <CarouselCommon cards={cards} maxWidth={22}/>

                </div>

            </section>
    );
};

export default WrapBizAdvice;
